export const formatProductName = (name) => {
  return encodeURIComponent(name.replace(/\s+/g, "~")); // Пробелы → ~, затем кодируем
};

export const decodeProductName = (slug) => {
  return decodeURIComponent(slug).replace(/~/g, " "); // Восстанавливаем пробелы, но оставляем дефисы
};